/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.MobileSharing = class MobileSharing {
  constructor(el, controller) {
    this._formSubmitted = this._formSubmitted.bind(this);
    this.el = el;
    this.controller = controller;
    this._bindEvents();
  }

  _bindEvents() {
    return this.el.find('button').on("click", this._formSubmitted);
  }

  _formSubmitted(e) {
    e.preventDefault();
    const button = $(e.currentTarget);

    if (button.data('shareUrl') === undefined) { return; }

    const text = this.el.find('[name=text]').val();

    const shareUrl = this._buildShareUrl(button.data(), text);

    eval(button.data("track-method") + "()");

    Buyapowa.Views.ShareTabs.hideMobileNotification();

    return window.top.location = shareUrl;
  }

  _buildShareUrl(data, text) {
    if (data.shareType === "fb_messenger") {
      return this._facebookShareUrl(data);
    }

    if (data.shareType === "sms") {
      return this._smsShareUrl(data, text);
    }

    if (data.shareType === "whatsapp") {
      return this._whatsAppShareUrl(data, text);
    }

    if (data.shareType === "line") {
      return this._lineShareUrl(data, text);
    }

    if (data.shareType === "viber") {
      return this._viberShareUrl(data, text);
    }

    if (data.shareType === "telegram") {
      return this._telegramShareUrl(data, text);
    }
  }

  _facebookShareUrl(data) {
    return `${data.url}${data.shareUrl}`;
  }

  _smsShareUrl(data, text) {
    let url;
    if (navigator.userAgent.match(/iphone|ipad|ipod/i)) {
      url = data.iosUrl;
    } else {
      ({
        url
      } = data);
    }

    const cleanedText = text.replace(/%/g, "'/.");

    return `${url}${encodeURIComponent(cleanedText)} ${data.shareUrl}`;
  }

  _whatsAppShareUrl(data, text) {
    return `${data.url}${encodeURIComponent(text)} ${data.shareUrl}`;
  }

  _lineShareUrl(data, text) {
    return `${data.url}${encodeURIComponent(text)} ${data.shareUrl}`;
  }

  _viberShareUrl(data, text) {
    return `${data.url}${encodeURIComponent(text)} ${data.shareUrl}`;
  }

  _telegramShareUrl(data, text) {
    return `${data.url}${encodeURIComponent(text)}&url=${data.shareUrl}`;
  }
};